import React from "react";
import Iconify from "../../components/iconify";

const getIcon = (name) => <Iconify icon={name} width={26} height={26} />;
const SideContent = [
  // {
  //   title: "Dashboard",
  //   path: "/dashboard",
  //   icon: getIcon("mingcute:invite-fill"),
  // },
  {
    title: "Users",
    path: "/users",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin'],

  },
  {
    title: "Languages",
    path: "/languages",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin', 'content_creator'],
  },
  {
    title: "Books",
    path: "/books",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin', 'content_creator'],
  },
  {
    title: "Chapters",
    path: "/chapters",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin', 'content_creator'],
  },
  {
    title: "Chapter Content",
    path: "/contents",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin', 'content_creator'],
  },
  {
    title: "Announcements",
    path: "/announcements",
    icon: getIcon("mingcute:invite-fill"),
    roles: ['admin', 'content_creator', 'announcement_manager'],
  },
 
];

export default SideContent;
